import { emptyState } from "../state";
import { generateBaseEntity } from "../entityFactory";
import { IState } from "../types";
import boardReducer from "./boardReducers";
import {
  activateGambitReducer,
  pickGambitReducer,
  swapGambitsReducer,
  updateGambitReducer,
  addGambitReducer
} from "./gambitReducers";
import turnReducer from "./turnReducer";
import { IReducerAction } from "./types";

function screenReducer(state: IState, action: IReducerAction): IState {
  if (!action.payload) return state;
  if (!("screen" in action.payload)) return state;
  const screen = {
    current: action.payload.screen,
    previous: state.screen.current
  };
  return { ...state, screen };
}

function loadStateReducer(state: IState, action: IReducerAction): IState {
  if (!action.payload) return emptyState;
  if (!("wave" in action.payload)) return state;
  const newState: IState = { ...state, waves: [action.payload.wave] };
  return screenReducer(newState, action);
}

function addActorReducer(state: IState): IState {
  const newActor = generateBaseEntity("owl");
  return { ...state, actors: state.actors.concat(newActor) };
}

// eslint-disable-next-line complexity, max-lines-per-function
function rootReducer(state: IState, action: IReducerAction): IState {
  switch (action.type) {
    case "state/empty":
      return loadStateReducer(state, action);
    case "state/loadWave":
      return loadStateReducer(state, action);
    case "changeTurn":
      return turnReducer(state);

    case "gambit/add":
      return addGambitReducer(state, action);
    case "gambit/swap":
      return swapGambitsReducer(state, action);
    case "gambit/activate":
      return activateGambitReducer(state, action);
    case "gambit/update":
      return updateGambitReducer(state, action);
    case "pick/pickGambit":
      return pickGambitReducer(state, action);

    case "actor/add":
      return addActorReducer(state);
    case "board/spendPoints":
      return boardReducer(state, action);
    case "screen/changeScreen":
      return screenReducer(state, action);

    default:
      return state;
  }
}

export default rootReducer;
